import ErpProductCategoryList from "./list";


if (document.body.getAttribute("data-current-path") === "erp/product_categories") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new ErpProductCategoryList();
    }
}